<script>
import Vue from 'vue';

Vue.component('HTMLHeader', {
  data: function() {
    return {
      left: 0,
      top: 64,
      unreachable_gates: false,
      daemon_unreachable: false,
      uniomd_unreachable: false,
      lpr_unreachable: false
    };
  },
  template: `
  <header>
    <div class="logo">
      <div class="icon">
        <i class="fa fa-walking"></i>
      </div>
      <div class="meta">
        Széchenyi István Egyetem
        <span>Beléptető rendszer v1.0</span>
      </div>
    </div>
    <div v-on:click="$root.toggleSearchMenu" class="search">
      <i class="fa fa-search"></i>
    </div>
    <div class="logged-user">
      <div class="icon" :style="avatar">

      </div>
      <div class="data">
        <div class="name">
          {{ $root.user.name }}
        </div>
        <div class="type">
          {{ $root.user.email }}
        </div>
      </div>
      <ul v-on:click="$root.toggleProfilMenu" class="toggle">
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
    <div class="statuses">
      <p>UNIOM daemon: <i :class="uniomd_status_icon" /> {{uniomd_status}}<br/>
      LPR process: <i :class="lpr_status_icon" /> {{lpr_status}}</p>
      <div v-show="false">Beléptető eszközök: <i :class="gates_statuses_icon" /> {{gates_statuses}}</p></div>
    </div>
    <Profilmenu/>
    <Search/>
  </header>
  `,
  mounted: function() {
    var _this = this;
    clearInterval(this.$root.header_interval);
    this.checkCheckerLog();
    this.$root.header_interval = setInterval(function() { 
      _this.checkCheckerLog() 
    }, 60000);
  },
  computed: {
    avatar: function() {
      if (this.$root.user.avatar != undefined && this.$root.user.avatar != '') {
        return "background-image:url('assets/img/"+this.$root.user.avatar+"')";
      } else {
        return '';
      }
    },
    daemon_status: function() {
      if(this.daemon_unreachable) {
        return "Nem fut";
      } else {
        return "Fut";
      }
    },
    daemon_status_icon: function() {
      if(this.daemon_unreachable) {
        return "fas fa-times";
      } else {
        return "fas fa-check";
      }
    },
    uniomd_status: function() {
      if(this.uniomd_unreachable) {
        return "Nem fut";
      } else {
        return "Fut";
      }
    },
    uniomd_status_icon: function() {
      if(this.uniomd_unreachable) {
        return "fas fa-times";
      } else {
        return "fas fa-check";
      }
    },
    gates_statuses: function() {
      if(this.daemon_unreachable) {
        return "Nincs kapcsolat";
      } else {
        if(this.unreachable_gates) {
          return "Nem érhető el minden eszköz";
        } else {
          return "Minden eszköz elérhető";
        }
      }
    },
    gates_statuses_icon: function() {
      if(this.daemon_unreachable) {
        return "fas fa-times";
      } else {
        if(this.unreachable_gates) {
          return "fas fa-exclamation";
        } else {
          return "fas fa-check";
        }
      }
    },
    lpr_status: function() {
      if(this.uniomd_unreachable) {
        return "Nem fut";
      } else {
        return "Fut";
      }
    },
    lpr_status_icon: function() {
      if(this.uniomd_unreachable) {
        return "fas fa-times";
      } else {
        return "fas fa-check";
      }
    },
  },
  methods: {
    checkCheckerLog: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('check_checkerlog/' + _this.$root.user.apikey, {
          success: function(response) {
            _this.unreachable_gates = response.unreachable_gates;
            //_this.daemon_unreachable = response.daemon_unreachable;
            _this.uniomd_unreachable = response.uniomd_unreachable;
            _this.lpr_unreachable = response.lpr_unreachable;
          }
        });
      });
    }
  }
});
</script>


// WEBPACK FOOTER //
// tpl_header.vue?4cbd5315